import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

function DashboardBarChart(props) {
  const { chartTitle, chartCategories, yAxisTitle, chartData } = props;

  const setOptions = {
    chart: {
      type: "column",
    },
    credits: {
      enabled: false,
    },
    title: {
      text: chartTitle,
    },

    xAxis: {
      categories: chartCategories,
      crosshair: true,
    },

    yAxis: {
      title: {
        text: yAxisTitle,
      },
      labels: {
        formatter: function () {
          return "₹" + this.value.toLocaleString("en-IN");
        },
      },
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      formatter: function () {
        let s = `<span style="font-size:10px">${this.x}</span><table>`;
        this.points.forEach((point) => {
          s += `<tr>
                  <td style="color:${point.series.color};padding:0">${point.series.name}: </td>
                  <td style="padding:0"><b>₹${point.y.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</b></td>
                </tr>`;
        });
        s += "</table>";
        return s;
      },
      footerFormat: "</table>",
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        cursor: "pointer",
      },
    },
    series: chartData,
    exporting: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={setOptions} />;
}

export default DashboardBarChart;